<template>
    <div>
    	<div>
	        <Row class="expand-row">
	        	<Table :no-data-text="$t('common.noData')" :columns="columns" :data="portListData" style="width: 100%;"></Table>
	        </Row>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            row: Object
        },
        data () {
            return {
                columns: [
                    {
                        title: this.$t('RAM.AWS.SecurityGroup.protocolType'),
                        key: 'protocolType'
                    },
                    {
                      title: this.$t('RAM.AWS.SecurityGroup.accessRules'),
                      key: 'accessRules'
                    },
                    {
                        title: this.$t('RAM.AWS.SecurityGroup.protocol'),
                        key: 'protocol'
                    },
                    {
                        title: this.$t('RAM.AWS.SecurityGroup.port'),
                        key: 'port'
                    },
                    {
                        title: this.$t('RAM.AWS.SecurityGroup.resource'),
                        key: 'source'
                    }
                ],
                portListData:this.row.portList
            }
        }
    };
</script>
<style scoped>
    .expand-row{
    	padding-left: 17px;
        margin-bottom: 10px;
    }
    .expand-key
    {
    	width: 145px;
    	display: block;
    	float: left;
    }
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/aws/security_group/TableExpand.vue